import './loader.css';
export default function PageLoader({ message }) {
  return (
    <div className="page-loader">
      <div className="page-loader-content">
        <div className="blinking">
          <img
            className="page-loader-logo"
            src="/images/logo.gif"
            alt="Loading..."
          />
        </div>
        {message && <div className="loader-message">{message}</div>}
      </div>
    </div>
  );
}
